import QRCode from 'qrcode'

document.addEventListener('DOMContentLoaded', function () {
  const canvas = document.getElementById('admin_vcard_qr_canvas')
  if (!canvas) return

  const payload = canvas.dataset.vcardQrText
  if (!payload) return

  const size = canvas.dataset.size ? parseInt(canvas.dataset.size, 10) : 512

  QRCode.toCanvas(canvas, payload, {
    errorCorrectionLevel: 'M',
    width: size,
    height: size
  }, function (error) {
    if (error) console.error(error)
  })
})
